<template>
    <div class="edit-questionnaire apprentice-simple-card">
        <div class="component-title">
            <h5 class="title">{{$t('questionnaire.form')}}</h5>
        </div>

        <design-2021-questionnaire-edit-section-component v-for="section in questionnaireIn.sections" :key="section.id" :section="section"></design-2021-questionnaire-edit-section-component>


        <div class="not-found with-header empty-questionnaire-list" v-if="questionnaireIn.sections.length === 0">
            <div class="btn-add-circle icon" :title="$t('questionnaire.create_section')" v-b-tooltip.hover v-b-modal="'questionnaire-edit-add-section-modal'">
            </div>
            <div class="alert-notice">{{$t('questionnaire.no_sections_found_in_this_questionnaire')}}</div>
        </div>

        <div class="new-section-container" v-if="questionnaireIn.sections.length >= 1">
            <b-button variant="primary"
                      class="btn-add"
                      v-b-modal="'questionnaire-edit-add-section-modal'">
                {{$t('questionnaire.new_section')}}
            </b-button>
        </div>
        <design-2021-questionnaire-edit-add-section-modal-component
            :questionnaire-in="questionnaireIn"
        ></design-2021-questionnaire-edit-add-section-modal-component>
    </div>
</template>

<script>

export default {
    name: "design-2021-questionnaire-edit-questionnaire-component",
    props:[
        'questionnaireIn'
    ],
    data(){
        return{
            sections: this.questionnaireIn.sections
        }
    },
    watch: {
        questionnaireIn: function (questionnaireIn) {
            this.sections = questionnaireIn.sections;
        }
    },
}

</script>

<style scoped lang="scss">
    .new-section-container {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: map-get($grid-gutter-spacing, 'forty-two');
    }

</style>
